import {
  FetchRemoteConfigurationUseCase,
  GeneralError,
  GetLocalesUseCase,
  LoadRemoteConstantsUseCase,
  LoadTripBookColorsUseCase
} from '51trips-frontend-core'
import { signInWithCustomToken } from 'firebase/auth'
import { useSetAtom } from 'jotai'
import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { take } from 'rxjs/operators'

import { auth } from '../firebase.ts'
import { LocalizeDataFormatRepository } from '../repositories/LocalizeDataFormatRepository.ts'
import { RemoteConfigurationRepository } from '../repositories/RemoteConfigurationRepository'
import { RemoteConstantsRepository } from '../repositories/RemoteConstantsRepository.ts'
import { configAtom, promoCodeAtom } from '../store/atoms'
import { toLoggableError, userReadableDescription } from '../utils/UserReadableDescription'

const fetchRemoteConfigurationUseCase = new FetchRemoteConfigurationUseCase(
  new RemoteConfigurationRepository()
)

const loadTripBookColorsUseCase = new LoadTripBookColorsUseCase(new RemoteConstantsRepository())

const loadRemoteConstantsUseCase = new LoadRemoteConstantsUseCase(new RemoteConstantsRepository())

const getLocalesUseCase = new GetLocalesUseCase(new LocalizeDataFormatRepository())
export const Root = () => {
  const setConfig = useSetAtom(configAtom)
  const setPromoCodeAtom = useSetAtom(promoCodeAtom)

  useEffect(() => {
    fetchRemoteConfigurationUseCase
      .fetchRemoteConfiguration()
      .pipe(take(1))
      .subscribe({
        error: (error: GeneralError) => {
          // No snackbar: the app keeps working on the cached config or the
          // defaults set in firebase.ts, so there is nothing for the user to do.
          // Mostly transient network failures on iOS Safari; logged for Sentry.
          console.error(toLoggableError(error))
        }
      })

    loadTripBookColorsUseCase.loadTripBookColors().subscribe({
      next: (colors) => {
        setConfig({
          colors: colors.map((c) => ({ id: c.id, hexColor: c.hexColor, isActive: c.isActive }))
        })
      }
    })

    const locale = getLocalesUseCase.getLocales()

    loadRemoteConstantsUseCase
      .loadRemoteConstants(locale)
      .pipe(take(1))
      .subscribe({
        next: (remoteConstants) => {
          const currentDate = new Date().getTime()
          if (
            remoteConstants.promoCode?.isActive &&
            remoteConstants.promoCode!.endDate! >= currentDate
          ) {
            setPromoCodeAtom(remoteConstants.promoCode)
          }
        },
        error: (error: GeneralError) => {
          userReadableDescription(error)
        }
      })
  }, [])

  useEffect(() => {
    const UrlParams = new URLSearchParams(window.location.search)

    const idToken = UrlParams.get('token')
    if (idToken) {
      console.log('Sign in with custom token: ', idToken)
      signInWithCustomToken(auth, idToken)
        .then((userCredential) => {})
        .catch((error) => {
          console.error('Error signing in with custom token:', error)
        })
    }
  }, [])

  return (
    <>
      <div id="detail">
        <Outlet />
      </div>
    </>
  )
}

export default Root
